import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import './inicio.css';

const Inicio = () => {

    const [t, i18n] = useTranslation("ideaCorta");


    return (
        <div className="_ngcontent-ng-c2574764019">
              <section _ngcontent-ng-c3297322628="" class="reflexiones-banner"
                aria-label="Frase destacada de Ricardo Salinas"><img _ngcontent-ng-c3297322628=""
                  src="/assets/img2026/reflexion_horizontal_banner.png" alt="Banner Ideas" class="reflexiones-banner__image"/>
                <div _ngcontent-ng-c3297322628="" class="reflexiones-banner__copy">
                  <p _ngcontent-ng-c3297322628="" class="reflexiones-banner__quote"> {t("2026.tit1")} <span _ngcontent-ng-c3297322628=""
                      class="reflexiones-banner__quote-emphasis">{t("2026.tit2")}</span>. </p>
                </div>
              </section>
            </div>
    );
};

export default Inicio;